import { API_DICTIONARY } from 'constants/api'
import { TCreatePaymentData, TPaymentData } from './types'
import { HTTP_METHODS } from 'constants/api'
import Fetcher from 'services/Fetcher'
import { TBankAccountsListResponse } from 'features/BankAccount/types'

const fetcher = new Fetcher({})

export const fetchPaymentData = async (id: string) =>
  fetcher.request<unknown, TPaymentData>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.REBATES_DASHBOARD}${id}/${API_DICTIONARY.PAYMENT}`,
    method: HTTP_METHODS.GET
  })

export const fetchPaymentOptions = async (businessAccountId: string) =>
  fetcher.request<unknown, TBankAccountsListResponse>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${businessAccountId}/${API_DICTIONARY.BANK_ACCOUNTS}?purposes=payable&statuses=verified&payment_method_type=ach-debit-collect`,
    method: HTTP_METHODS.GET
  })

export const createPayment = async (id: string, data: TCreatePaymentData) =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.REBATES_DASHBOARD}${id}/${API_DICTIONARY.PAYMENT}`,
    method: HTTP_METHODS.POST,
    data
  })

export const fetchMarketplaceARPaymentData = async (id: string) =>
  fetcher.request<unknown, TPaymentData>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.MARKETPLACE_AR}${id}/${API_DICTIONARY.PAYMENT}`,
    method: HTTP_METHODS.GET
  })

export const createMarketplaceARPayment = async (
  id: string,
  data: TCreatePaymentData
) =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.MARKETPLACE_AR}${id}/${API_DICTIONARY.PAYMENT}`,
    method: HTTP_METHODS.POST,
    data
  })
